import React, { useState } from "react";
import SelectMetersDialog from "./SelectMetersDialog.js";
import AddIcon from "@mui/icons-material/Add";
import CustomDialog from "components/CustomDialog/CustomDialog.js";

export default function UploadMetersDialog(props) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <CustomDialog
      id="addTURPE"
      handleClose={handleClose}
      open={open}
      maxWidth="md"
      dialogTitle="Selection de compteurs"
      dialogContent={<SelectMetersDialog closeModal={handleClose} {...props} />}
      handleClickOpen={handleClickOpen}
      icon={
        <AddIcon
          fontSize="small"
          style={{
            marginRight: "6px",
          }}
        />
      }
      buttonName="Selection de compteurs"
    />
  );
}
